import { React, useState } from "react";
import Backdrop from "@mui/material/Backdrop";
import Box from "@mui/material/Box";
import Modal from "@mui/material/Modal";
import Fade from "@mui/material/Fade";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import CancelIcon from "@mui/icons-material/Cancel";
import Image from "../../../images/otpModal.png";
import { InputAdornment, TextField } from "@mui/material";
import { Link, useNavigate } from "react-router-dom";
import axios from "axios";
import { setAuthToken } from "../../../utils/setAuthToken";
import VisibilityOffIcon from "@mui/icons-material/VisibilityOff";
import VisibilityIcon from "@mui/icons-material/Visibility";
import ViewAPIModal from "./apiModal";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { SHA256 } from "crypto-js";
import Pin from "../../Login/pin";
const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  maxWidth: 525,
  width: "100%",
  minWidth: "303px!important",
  "@media(max-width:600px)": { width: "303px!important" },
  bgcolor: "#FFFFFF",
  borderRadius: "24px",
  boxShadow: 24,
  p: "1rem 1.4rem ",
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
};

export default function ChangePinModal(props) {
  //Normal use states
  const [newPass, setNewPass] = useState("");
  const [confirmNewPass, setConfirmNewPass] = useState("");
  const calculateHash = (inputValue) => {
    const hashedValue = SHA256(inputValue).toString();
    return hashedValue;
  };
  const navigate = useNavigate();
  const updatePin = (e) => {
    setAuthToken(localStorage.getItem("jwtToken"));
    axios
      .post("https://api.blockpay.co.za/merchant/updateMerchantPin", {
        newPin: calculateHash(newPass),
        confirmPin: calculateHash(confirmNewPass),
      })
      .then((res) => {
        toast.success(res.data.message);
        console.log(res);
        window.location.reload();
      })
      .catch((err) => {
        toast.error(err.response.data.message);
        console.log(err);
        if (err.response.data.message == "Unauthorized!") {
          axios
            .post("https://api.blockpay.co.za/auth/refreshToken", {
              refreshToken: localStorage.getItem("refreshToken"),
            })
            .then((res) => {
              console.log(res);
              localStorage.setItem("jwtToken", res.data.accessToken);
              setTimeout(() => {
                window.location.reload();
              }, 500);
            })
            .catch((err) => {
              console.log(err);
              localStorage.clear();
              window.location.reload();
            });
        }
      });
  };
  return (
    <div>
      <ToastContainer />
      <Modal
        aria-labelledby="transition-modal-title"
        aria-describedby="transition-modal-description"
        {...props}
        closeAfterTransition
        slots={{ backdrop: Backdrop }}
        slotProps={{
          backdrop: {
            timeout: 500,
          },
        }}
      >
        <Fade in={props.open}>
          <Box sx={style}>
            <Box
              sx={{
                color: "#919191",
                marginLeft: "auto",
              }}
              onClick={props.onClose}
            >
              <CancelIcon />
            </Box>
            <Box
              component="img"
              src={Image}
              sx={{ height: "200px", width: "230px" }}
            />
            <Typography
              id="transition-modal-title"
              variant="h5"
              component="h2"
              sx={{ fontWeight: "500", lineHeight: "2.421rem" }}
            >
              Change Pin
            </Typography>
            <Typography
              id="transition-modal-description"
              sx={{
                mt: 1,
                mb: 2,
                fontSize: "16px!important",
                color: "#626262",
                textAlign: "center",
              }}
            >
              Change your Pin in one click here!
            </Typography>
            <Box sx={{ textAlign: "left", mb: "0.5rem", width:"100%" }} className="otpInput">
              <p className="pinPlaceholder">New Smart Pin *</p>
              <Pin otp={newPass} setOtp={setNewPass} />
              {/* <Typography className="loginFPass">Forget Pin?</Typography> */}
            </Box>
            <Box sx={{ textAlign: "left", mb: "0.5rem" , width:"100%"}} className="otpInput">
              <p className="pinPlaceholder">Confirm new Smart Pin *</p>
              <Pin otp={confirmNewPass} setOtp={setConfirmNewPass} />
              {/* <Typography className="loginFPass">Forget Pin?</Typography> */}
            </Box>

            <Button
              className="loginButtonSignUp"
              variant="contained"
              color="primary"
              size="large"
              type="submit"
              onClick={updatePin}
              disabled={newPass === "" || !confirmNewPass}
              sx={{ textTransform: "none", borderRadius: "10px", mb: "1rem" }}
            >
              <span className="buttonSignText">Change Pin</span>
            </Button>
          </Box>
        </Fade>
      </Modal>
    </div>
  );
}
